import contactFormTranslation from './contact-form/index.json';
import mapTranslation from './map/index.json';

const contactTranslation = {
    contactForm: contactFormTranslation,
    map: mapTranslation,
};

export default contactTranslation;
